import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseAdministratorAccess from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAdministratorAccess';

const pageSchema = GatewayGetSchema.pages.administratorAccess;
const pageId = pageSchema.pageId;

function PlanAdministratorAccess({
    planObject,
    setPlanData
}) {
    let pageData = planObject[pageId];

    return (
        <BaseAdministratorAccess
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanAdministratorAccess;